<template>
  <v-menu
    :close-on-content-click="false"
    bottom
    close-delay="100"
    max-width="320px"
    min-width="320px"
    nudge-bottom="8px"
    offset-y
    open-delay="200"
    open-on-hover
    left
  >
    <slot name="activator" slot="activator"></slot>
    <v-card flat>
      <v-card-title style="height: 50px">
        <p style="font-size: 17px">站内未读消息</p>
      </v-card-title>
      <v-card-text>
        <v-list>
          <v-layout v-for="(n,i) in notificationList" :key="i" column>
            <v-divider></v-divider>
            <v-list-tile @click="goDetails">
              <v-list-tile-content class="pa-1">
                <v-list-tile-title>{{n.title}}</v-list-tile-title>
                <v-list-tile-sub-title class="caption">{{$L.time.stringify(n.creationTime)}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-layout>
        </v-list>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-layout justify-center>
          <v-btn flat color="primary">查看更多</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'notificationMenu',
  props: ['value'],
  data () {
    return {
      activate: false
    }
  },
  computed: {
    notificationList () {
      // console.log(this.$store.state.message.notificationList)
      return this.$store.state.message.notificationList
    },
    value_: {
      get () {
        if (this.value === undefined) {
          return this.activate
        }
        else {
          return this.value
        }
      },
      set (val) {
        if (this.value === undefined) {
          this.activate = val
        }
        else {
          this.$emit('input', val)
        }
      }
    },
  },
  created () {
    console.log(this.notificationList)
  },
  methods: {
    goDetails () {

    }
  }
}
</script>

<style scoped>

</style>
